 export const isRequestHeaderFromChromiumBrowserSource = () => {
	 if (navigator.userAgent.toLowerCase().indexOf('qtwebengine') !== -1) {
		 return true;
	 } else {
		 return false;
	 }
 }
